export default __webpack_public_path__ + "static/media/SHIBX.c2eb0fcb.png";